<div class="switch-container">
  <label class="switch">
    <input type="checkbox" [checked]="value" (change)="onToggle()" />
    <span class="slider round"></span>
  </label>
</div>
